import React, { useState } from 'react';
import styled from 'styled-components';
import ImageCard from './ImageCard';
import slugifyTitle from '../hooks/slugifyTitle';
import LoadMore from './LoadMore';

const StyledImageRow = styled.div`
  position: relative;

  .image-row {
    display: grid;
    grid-template-columns: ${(props) => (props.fourCols ? '1fr 1fr 1fr 1fr' : '1fr 1fr 1fr')};
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    max-width: 74.5rem;
    margin: 0 auto;
  }

  .gradient {
    position: absolute;
    z-index: 2;
    right: 0;
    bottom: 0;
    left: 0;
    height: 20rem;
    background: -moz-linear-gradient(top, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 30%);
    background: -webkit-gradient(
      linear,
      left top,
      left bottom,
      color-stop(0%, rgba(255, 255, 255, 0)),
      color-stop(30%, rgba(255, 255, 255, 1))
    );
    background: -webkit-linear-gradient(top, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 30%);
    background: -o-linear-gradient(top, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 30%);
    background: -ms-linear-gradient(top, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 30%);
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 30%);
  }

  @media (max-width: 1200px) {
    .image-row {
      padding: 0;
      grid-template-columns: 1fr 1fr 1fr;
    }
  }

  @media (max-width: 1100px) {
    .image-row {
      grid-template-columns: 1fr 1fr;
    }
  }

  @media (max-width: 800px) {
    .image-row {
      grid-template-columns: 1fr;
    }
  }
`;

const imageCount = 9;

// ImageRow cols prop can be 3 or 4 per design specs
const ImageRow = ({ images, loadMore, four, noType }) => {
  const [next, setNext] = useState(imageCount);
  return (
    <>
      <StyledImageRow fourCols={images.some((img) => img.doubleWidth === true) || four}>
        <div className="image-row">
          {loadMore
            ? images.slice(0, next).map((image, idx) => {
                return (
                  <ImageCard
                    src={image.image}
                    alt={image?.alt}
                    date={image.date}
                    title={image.title}
                    description={image.description}
                    doubleWidth={image.doubleWidth}
                    type={image.type}
                    link={'/' + image.title && slugifyTitle(image.title, `/${image.type}/`)}
                    rowMargin={'3rem'}
                    key={idx}
                    noType={noType}
                  />
                );
              })
            : images.map((image, idx) => {
                return (
                  <ImageCard
                    src={image.image}
                    alt={image?.alt}
                    date={image.date}
                    title={image.title}
                    description={image.description}
                    doubleWidth={image.doubleWidth}
                    type={image.type}
                    link={image.title && slugifyTitle(image.title, `/${image.type}/`)}
                    rowMargin={'3rem'}
                    key={idx}
                    noType={noType}
                  />
                );
              })}
        </div>

        {loadMore && next < images.length && <div className="gradient" />}
        {loadMore && next < images.length && (
          <LoadMore onClick={() => setNext(next + imageCount)} />
        )}
      </StyledImageRow>
    </>
  );
};

export default ImageRow;
